import { createWorldTerrain, Ion } from 'cesium';

Ion.defaultAccessToken = import.meta.env.VITE_CESIUM_ACCESS_TOKEN ?? '';

export const terrainProvider = createWorldTerrain();
